<template>
  <div :class="[
         'scrollable',
         $style.scrollable
       ]"
       @scroll="$emit('scroll', $event)"
  >
    <slot/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
/*
 *
 * b-scrollable component
 *
 */
export default defineComponent({

  emits: [
    'scroll',
  ],
  name: 'b-scrollable',
})

</script>

<style lang="scss" module>
@layer legacy-views {

.scrollable {
  overflow: auto;
}

}</style>
